import React from 'react';
import { Instagram, MapPin, Heart } from 'lucide-react';
import { siteInfo } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#f0f0f0] border-t border-[#bcbbb4]/30">
      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-20">
          {/* Brand */}
          <div>
            <div className="mb-6">
              <h3 className="font-display text-xl font-light tracking-[0.15em] text-[#333]">
                {siteInfo.name}
              </h3>
            </div>
            <p className="body-regular text-[#666] leading-relaxed">
              Maquilladora profesional especializada en novias y eventos exclusivos.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="font-body text-xs tracking-[0.2em] text-[#333] uppercase mb-6">
              Navegación
            </h4>
            <nav className="flex flex-col gap-4">
              <button
                onClick={() => scrollToSection('sobre-mi')}
                className="text-left font-body text-sm text-[#666] hover:text-[#333] transition-colors"
              >
                Sobre mí
              </button>
              <button
                onClick={() => scrollToSection('novias')}
                className="text-left font-body text-sm text-[#666] hover:text-[#333] transition-colors"
              >
                Novias
              </button>
              <button
                onClick={() => scrollToSection('galeria')}
                className="text-left font-body text-sm text-[#666] hover:text-[#333] transition-colors"
              >
                Galería
              </button>
              <button
                onClick={() => scrollToSection('contacto')}
                className="text-left font-body text-sm text-[#666] hover:text-[#333] transition-colors"
              >
                Contacto
              </button>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-body text-xs tracking-[0.2em] text-[#333] uppercase mb-6">
              Contacto
            </h4>
            <div className="flex flex-col gap-4">
              <a
                href={siteInfo.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-3 text-sm text-[#666] hover:text-[#333] transition-colors"
              >
                <Instagram size={16} strokeWidth={1.5} />
                <span>{siteInfo.instagramHandle}</span>
              </a>
              <div className="flex items-center gap-3 text-sm text-[#666]">
                <MapPin size={16} strokeWidth={1.5} />
                <span>{siteInfo.locations.join(' · ')}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-[#bcbbb4]/30 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-xs text-[#666]">
              © {currentYear} {siteInfo.name}. Todos los derechos reservados.
            </p>
            <p className="flex items-center gap-1 text-xs text-[#666]">
              Hecho con <Heart size={12} className="text-[#ba3e2b]" fill="#ba3e2b" /> en España
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
